
export const navbar = {
    home: '首页',
    aiWorkbench: 'AI工作台',
    mvGeneration: '音乐生成',
    myCreations: '我的创作',
    pricing: '定价',
    showcase: '展示',
    profile: '个人资料',
    logout: '退出',
    signIn: '登录'
  };
